import React from 'react';
import { PATHS } from '@constants';
import { NavLink } from 'react-router-dom';
import Icon from '@components/Icon';
import './style.scss';

const HeaderMenuItem = ({
  linkTo, isActive, title, icon, greenTheme,
}) => (
  <div className={`header-menu__item label-lg tablet-label-lg mobile-label-lg ${greenTheme ? 'header-menu__item_green' : ''}`}>
    <NavLink to={linkTo} exact={linkTo === PATHS.HOME} className={`${isActive ? 'active' : ''}`}>
      <Icon type={icon} />
      <span>{title}</span>
    </NavLink>
  </div>
);

export default HeaderMenuItem;
